import { render, staticRenderFns } from "./PackagesTypeList.vue?vue&type=template&id=76f7a524"
import script from "./PackagesTypeList.vue?vue&type=script&lang=js"
export * from "./PackagesTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports